import ButtonImageSliced from '../ButtonImageSliced.js';
import { Colors } from '../../consts/Colors.js';
import QcmA2 from './QcmA2.js';

export default class Part2 extends Phaser.GameObjects.Container {
    constructor(scene, partData, screenManager) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;
        this.partData = partData
        this.step = 0
        this.screenManager = screenManager

        this.partContainer = this.scene.add.container(1920, 0);
        this.add(this.partContainer);
this.scene.addSounds()

        this.qcm = new QcmA2(this.scene, this.partData[0], this);
        this.partContainer.add(this.qcm)
        this.animateIn(1)
    }

    changeScreen() {
        this.qcm?.destroy()
        this.screenData = this.partData[this.step];
        this.transitionOut(() => {
            this.createNavButtons()
            this.buildBaseTexts()
            this.createMainImage()
            this.addBulletList()
            this.animateIn(2)
        })
    }

    nextFunction() {
        switch (this.step) {
            case 1:
                this.step = 2
                this.transitionOut(() => {
                    this.changeScreen()
                    // this.animateIn(3)
                })
                break;

            case 2:
                this.screenManager.changePart(3)
                break;

        }
    }
    previewFunction() {
        switch (this.step) {
            case 2:
                this.step = 1
                this.transitionOut(() => {
                    this.changeScreen()
                    this.animateIn(4)
                })
                break
        }
    }

    createNavButtons() {
        this.nextBtn = new ButtonImageSliced(this.scene, 1710, 990, 320, 80, "bouton", "Suivant");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => this.nextFunction());
        if (this.step !== 1) {
            this.previewBtn = new ButtonImageSliced(this.scene, 220, 990, 320, 80, "bouton", "Précédent");
            this.add(this.previewBtn);
            this.previewBtn.setClickFunction(() => this.previewFunction());
        }
    }

    buildBaseTexts() {
        this.title = this.scene.createTextElement(this.screenData.title.titleX, this.screenData.title.titleY, this.screenData.title);
        this.partContainer.add(this.title);
        this.content = this.scene.createTextElement(this.screenData.content.contentX, this.screenData.content.contentY, this.screenData.content);
        this.partContainer.add(this.content);
    }

    addBulletList() {
        this.scene.createBulletList(this.screenData.bulletList, this.screenData.bulletX, this.screenData.bulletY, this.partContainer)
    }

    createMainImage() {
        this.image = this.scene.add.image(this.screenData.imgX, this.screenData.imgY, this.screenData.img).setOrigin(0.5);
        this.partContainer.add(this.image);
    }
    animateIn(step) {
        this.scene.playSound('whoosh');
        console.log("whoosh triggered step ", step);
        this.scene.tweens.add({
            targets: this.partContainer,
            x: 0,
            duration: 300,
            ease: 'Power2'
        });
    }

    transitionOut(onComplete) {
        // Remove nav buttons to avoid duplicate handlers
        this.nextBtn?.destroy();
        this.previewBtn?.destroy();
        this.scene.tweens.add({
            targets: this.partContainer,
            x: 1920,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.partContainer.destroy();
                this.partContainer = this.scene.add.container(1920, 0);
                this.add(this.partContainer);
                onComplete && onComplete();
            }
        });
    }

}